<template>
  <div class="body_detail">
    <div class="filter_condition">
      <div class="condition_tag">
        筛选条件：
        <el-tag :key="1" size="medium" v-if="index">{{index}}</el-tag>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          size="medium"
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
      </div>
      <el-radio-group v-model="tabPosition" size="mini"  class="sort_button" v-if="false">
        <el-radio-button label="相关性" v-if="false">相关性<i class="header-icon el-icon-sort"></i></el-radio-button>
        <el-radio-button label="时间" >时间<i class="header-icon el-icon-sort"></i></el-radio-button>
      </el-radio-group>
      <div class="btn_sort" @click="changeSort" :title="sort == 'desc' ? '降序' : '升序' " v-if="$route.path == '/contentsearch' || $route.path == '/readmore'" >
        <span>时间</span>
        <img v-if="sort" class="sort_icon" :src="sort == 'desc' ? '../static/img/desc.png' : '../static/img/asc.png'"/>
      </div>
    </div>
    <div class="content" v-if="index">
      <span class="content_result">搜索<strong>"{{index}}"</strong>共找到{{total}}个相关结果</span>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      index:{
        type:String,
        default:''
      },
      total:{
        type:Number,
        default:0
      },
      sort:{
        type:String
      }
    },
    data() {
      return {
        dynamicTags: [],
        inputVisible: false,
        inputValue: [],
        tabPosition: '相关性',
        node:{},
        searchList:[]
      };
    },
    mounted(){
      //console.log(this.total)
      this.$nextTick(()=>{
      })
    },
    methods: {
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        //console.log(tag)
        this.$emit('deleteType',tag)
      },
      deleteTag(tag){
        //debugger
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      addSearchKey(key){
        this.inputValue.push(key)
        var k = 0
        if (this.inputValue != '') {
          this.dynamicTags.push(key);
        }
        this.inputValue = [];
      },
      addNameCondition(inputValue,nameList){
        this.inputValue.push(inputValue);
        if (this.inputValue){
          this.inputValue.reverse()
          for(var j=0;j<this.inputValue.length;j++){
            var k = 0
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.dynamicTags[i]!=this.inputValue[j]){
                k++
              }else{
                break;
              }
            }
            if(k==this.dynamicTags.length){
              for(var z = 0;z < this.dynamicTags.length;z++){
                for(var k = 0;k < nameList.length;k++){
                  var a = nameList[k].name
                  if(this.dynamicTags[z].indexOf(a) > -1){
                    this.handleClose(a)
                    break
                  }
                }
              }
              this.dynamicTags.push(this.inputValue[j])
              //console.log(this.inputValue)
            }else{
              console.log('已经存在')
            }
          }
        }
        this.inputValue = [];
      },
      addCondition(statistical, searchGroup) {
        this.inputValue.push(statistical.data.key)
        // this.searchList.push(statistical)
        // console.log(this.searchList)
        let statisticalParent = statistical.parent
        while(statisticalParent && statisticalParent.data.key){
          if(statistical.data.key != statisticalParent.data.key)
          {
            this.inputValue.push(statisticalParent.data.key)
          }
          statisticalParent = statisticalParent.parent
        }
        if (this.inputValue){
          if (searchGroup === 'address') {
            let storage = window.localStorage
            let loc = storage.getItem('address').split('-')
            let level = this.inputValue.length - loc.length
            if (level > 1) {
              this.dynamicTags.push(this.inputValue[1])
              this.dynamicTags.push(this.inputValue[0])
            } else if (level > 0 && level < 2) {
              this.dynamicTags.push(this.inputValue[0])
            }
          } else {
            this.inputValue.reverse()
            for(var j=0;j<this.inputValue.length;j++){
              var k = 0
              for(var i=0;i<this.dynamicTags.length;i++){
                if(this.dynamicTags[i]!=this.inputValue[j]){
                  k++
                }else{
                  break;
                }
              }
              if(k==this.dynamicTags.length){
                this.dynamicTags.push(this.inputValue[j])
                //console.log(this.inputValue)
              }else{
                console.log('已经存在')
              }
            }
          }
        }
        this.inputValue = [];
      },
      initdynamicTags(query){
        //console.log(query)
        for(var i in query){
          //console.log(i,':',this.searchType[i])
          if(query[i] != ''){
            if(i != 'index' && i != 'from' && i != 'sort' && i != 'size' && i != 'id' && i != 'type'){
              var initCondition = []
              if (i === 'address') {
                let storage = window.localStorage
                let loc = storage.getItem('address').split('-')
                var initCondition = query[i].split("-")
                let level = initCondition.length - loc.length
                if (level > 1) {
                  this.dynamicTags.push(initCondition[initCondition.length-2])
                  this.dynamicTags.push(initCondition[initCondition.length-1])
                } else if (level > 0 && level < 2) {
                  this.dynamicTags.push(initCondition[initCondition.length-1])
                }
              } else if (i === 'date'){
                let date
                if(query[i].indexOf('h') > -1){
                  date = query[i].replace(/h/,"小时内")
                }
                else if(query[i].indexOf('d') > -1){
                  date = query[i].replace(/d/,"天内")
                }
                else if(query[i].indexOf('y') > -1){
                  date = query[i].replace(/y/,"年内")
                }
                this.dynamicTags.push(date)
              } else {
                var initCondition = query[i].split("-")
                for(var j=0;j<initCondition.length;j++){
                  this.dynamicTags.push(initCondition[j])
                  if(initCondition[j+1]){
                    if(initCondition[j] === initCondition[j+1]){
                      this.dynamicTags.pop()
                    }
                  }
                }
              }
              initCondition = []
              //console.log(initCondition)
            }
          }
        }
      },
      changeSort(){
        this.$emit('changeSort')
        //console.log(this.tabPosition)
      }
    },
    watch:{
      sort(newVal){
        this.sort = newVal
      }
    }
  }
</script>

<style>
  .filter_condition{
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    display: flex;
    padding: 15px 15px 10px 15px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
  }
  .condition_tag{
    width: 90%;
    height: 20px;
    color: #666666;
    font-size: 16px;
  }
  .condition_tag .el-tag{
    font-size: 14px;  
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .condition_tag .el-tag--small {
    height: 24px;
    padding: 0 6px;
    line-height: 24px;
  }
  .sort_button .el-radio-button--mini .el-radio-button__inner {
    height: 24px;
    padding: 0 6px;
    line-height: 24px;
    width: 80px;
  }
  .sort_button .el-radio-button--mini .el-radio-button__inner {
    height: 24px;
    padding: 0 6px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 0;
    width: 80px;
  }
  .sort_button .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 4px 0 0 4px;
    width: 80px;
  }
  .sort_button .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 4px 4px 0;
    width: 80px;
  }
  .content{
    padding: 20px;
  }
  .content_result{
    font-size: 24px;
    font-family: 思源黑体;
    color: #666;
  }
  .sort_button .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #47A1FF;
    width: 80px;
    background-color: #fff;
    border-color: #47A1FF;
    -webkit-box-shadow: -1px 0 0 0 #409EFF;
    box-shadow: -1px 0 0 0 #409EFF;
  }
  .sort_button .el-radio-group {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 162px;
  }
  .btn_sort{
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    cursor: pointer;
    padding: 7px 15px;
    font-size: 12px;
    font-family:思源黑体;
    color:rgba(102,102,102,1);
    display: flex;
    align-items: center
  }
  .btn_sort:hover{
    background-color: #EBF5FF;
    color:#359AFF;
    border-color: #359AFF;
  }
  .sort_icon{
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/filterCondition.vue